import { render, staticRenderFns } from "./myOrganisationDevices.vue?vue&type=template&id=08744d40&"
import script from "./myOrganisationDevices.vue?vue&type=script&lang=js&"
export * from "./myOrganisationDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports